import React from 'react'

import { OrderBillItem } from 'compositions/orderItems'


type CartBillProps = {
  className?: string
  bill: OrderItems.BillItem[]
}

const CartBill: React.FunctionComponent<CartBillProps> = (props) => {
  const { className, bill } = props

  return (
    <div className={className}>
      {
        bill.map((item, index) => {
          const { label, note, value, isSubTotal, isTotal, dataTestId } = item

          return (
            <OrderBillItem
              key={index}
              className={index ? 'mt-16' : null}
              label={label}
              note={note}
              value={value}
              size={(isSubTotal || isTotal) ? 'big' : 'medium'}
              data-testid={dataTestId}
            />
          )
        })
      }
    </div>
  )
}


export default CartBill
